/* ============================================================
   KORE Nav — scrollspy + navegación por anclas del macro-scroll.

   - Zonas: nodos [data-kore-zone] (snippets/kore-anchor, siempre
     FUERA de los stages sticky del pin → su rect es fiable aunque
     el pin infle la altura del wrapper)
   - Ilumina el link del menú (desktop + drawer) cuya ancla coincide
     con la zona activa: último anchor por encima de la línea de
     lectura (header + 35% del viewport)
   - Click en link de zona estando en la home → smooth scroll
     (auto con prefers-reduced-motion) + pushState; desde otras
     páginas el enlace /#zona navega normal
   - Click en el logo (o cualquier enlace a la raíz) en la home →
     scroll suave arriba
   - El scroll va en captura: el tema desplaza .page-wrapper, no
     window. Un MutationObserver recompone los links si Horizon
     re-renderiza el menú (overflow-list).
   ============================================================ */
(function () {
  'use strict';
  if (window.KoreNav) return;
  window.KoreNav = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var zones = [];     /* [{ id, el }] en orden DOM */
  var zoneLinks = {}; /* id → [links del header] */
  var current = null;
  var raf = 0;
  var relinkTimer = 0;

  function rootPath() {
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    } catch (e) { /* noop */ }
    return '/';
  }
  function isRootPath(path) {
    var root = rootPath();
    return path === root || path + '/' === root || path === '' || path === '/';
  }
  function behavior() { return reduce.matches ? 'auto' : 'smooth'; }

  function collectZones() {
    zones = [];
    var nodes = document.querySelectorAll('[data-kore-zone]');
    for (var i = 0; i < nodes.length; i++) {
      zones.push({ id: nodes[i].getAttribute('data-kore-zone'), el: nodes[i] });
    }
  }

  function collectLinks() {
    zoneLinks = {};
    var links = document.querySelectorAll('#header-group a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      /* El selector de idioma no es navegación de la home: en /ca, «ES»
         apunta a / y se tomaría por «volver arriba» sin cambiar de idioma. */
      if (a.closest('.kore-lang')) continue;
      var url;
      try { url = new URL(a.getAttribute('href'), location.origin); } catch (e) { continue; }
      if (url.origin !== location.origin) continue;
      if (url.hash && isRootPath(url.pathname)) {
        var z = url.hash.slice(1);
        (zoneLinks[z] = zoneLinks[z] || []).push(a);
        if (!a.dataset.koreNav) {
          a.dataset.koreNav = '1';
          a.addEventListener('click', onZoneClick);
        }
      } else if (!url.hash && isRootPath(url.pathname)) {
        if (!a.dataset.koreNavTop) {
          a.dataset.koreNavTop = '1';
          a.addEventListener('click', onTopClick);
        }
      }
    }
  }

  function closeDrawer(link) {
    var details = link.closest('details[id^="Details-menu-drawer"]');
    if (details) details.open = false;
  }

  function onZoneClick(e) {
    if (!zones.length) return; /* fuera de la home: navegación normal a /#zona */
    var url;
    try { url = new URL(e.currentTarget.getAttribute('href'), location.origin); } catch (err) { return; }
    var target = document.getElementById(url.hash.slice(1));
    if (!target) return;
    e.preventDefault();
    closeDrawer(e.currentTarget);
    target.scrollIntoView({ behavior: behavior(), block: 'start' });
    try { history.pushState(null, '', url.hash); } catch (err) { /* noop */ }
  }

  function onTopClick(e) {
    if (!zones.length) return;
    e.preventDefault();
    closeDrawer(e.currentTarget);
    var scroller = document.querySelector('.page-wrapper');
    if (scroller && scroller.scrollTo) scroller.scrollTo({ top: 0, behavior: behavior() });
    window.scrollTo({ top: 0, behavior: behavior() });
    try { history.pushState(null, '', location.pathname); } catch (err) { /* noop */ }
  }

  function headerOffset() {
    var v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
    return (isNaN(v) ? 64 : v) + 14;
  }

  function update() {
    raf = 0;
    if (!zones.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var line = headerOffset() + vh * 0.35;
    var active = zones[0].id;
    for (var i = 0; i < zones.length; i++) {
      if (zones[i].el.getBoundingClientRect().top <= line) active = zones[i].id;
    }
    current = active;
    /* Reaplicar siempre (no solo al cambiar): el re-render del menú de
       Horizon puede borrar la clase; toggle a mismo estado es no-op barato. */
    for (var id in zoneLinks) {
      if (!Object.prototype.hasOwnProperty.call(zoneLinks, id)) continue;
      var links = zoneLinks[id];
      for (var j = 0; j < links.length; j++) {
        links[j].classList.toggle('kore-nav-current', id === active);
      }
    }
  }

  function schedule() { if (!raf) raf = requestAnimationFrame(update); }

  /* Header flotante: al tope de la página la cápsula reposa sobre su
     banda (mismo navy → un solo bloque); en cuanto se baja, la banda se
     desvanece y la cápsula recupera filo+sombra = efecto flotante.
     Se resuelve por clase porque Horizon no togglea data-sticky-state
     en modo sticky='always'. El scroller real es .page-wrapper. */
  var liftDone = false;
  function initHeaderLift() {
    if (liftDone) return;
    liftDone = true;
    var group = document.getElementById('header-group');
    if (!group) return;
    var scroller = document.querySelector('.page-wrapper');
    var ticking = false;
    function apply() {
      ticking = false;
      var y = scroller ? scroller.scrollTop : (window.scrollY || document.documentElement.scrollTop || 0);
      group.classList.toggle('kore-header-lifted', y > 6);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    apply();
  }

  /* El overflow-list de Horizon mueve/reconstruye items del menú:
     recomponer el mapa de links cuando cambie el DOM del header. */
  function watchHeader() {
    var group = document.getElementById('header-group');
    if (!group || !window.MutationObserver) return;
    new MutationObserver(function () {
      clearTimeout(relinkTimer);
      relinkTimer = setTimeout(function () { collectLinks(); schedule(); }, 120);
    }).observe(group, { childList: true, subtree: true });
  }

  function init() {
    collectZones();
    collectLinks();
    update();
  }

  document.addEventListener('scroll', schedule, { capture: true, passive: true });
  window.addEventListener('resize', function () { collectLinks(); schedule(); });
  window.addEventListener('load', function () { update(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); watchHeader(); initHeaderLift(); });
  } else {
    init();
    watchHeader();
    initHeaderLift();
  }
  /* Reinyección en el editor de temas */
  document.addEventListener('shopify:section:load', function () { init(); });
})();
